import { render, staticRenderFns } from "./OrderRegisterDialog.vue?vue&type=template&id=44b8c6b3&scoped=true&"
import script from "./OrderRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./OrderRegisterDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b8c6b3",
  null
  
)

export default component.exports